const DAY = 86400000;

export function parseDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? date : null;
}

export function todayUTC() {
  const today = new Date();
  return new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate()));
}

export const addDays = (date, days) => new Date(date.getTime() + days * DAY);
export const daysBetween = (start, end) => Math.round((end.getTime() - start.getTime()) / DAY);
export const dateInput = (date) => date.toISOString().slice(0, 10);
export const formatDate = (date) => new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(date);
export const gestationalAge = (days) => `${Math.floor(days / 7)} semanas e ${days % 7} dias`;

export function trimester(days) {
  if (days < 98) return '1º trimestre';
  if (days < 196) return '2º trimestre';
  return '3º trimestre';
}

export function birthClass(days) {
  if (days < 259) return 'Pré-termo';
  if (days < 273) return 'Termo precoce';
  if (days < 287) return 'Termo pleno';
  if (days < 294) return 'Termo tardio';
  return 'Pós-termo';
}

function redatingThreshold(usDays) {
  if (usDays < 63) return 5;
  if (usDays < 98) return 7;
  if (usDays < 112) return 7;
  if (usDays < 154) return 10;
  if (usDays < 196) return 14;
  return 21;
}

export function calculate(method, values) {
  const now = todayUTC();
  const dum = parseDate(values.dum);
  const exam = parseDate(values.exam);
  const conception = parseDate(values.conception);
  const transfer = parseDate(values.transfer);
  const validDate = (date) => date && date <= now;
  const usDays = Number(values.weeks) * 7 + Number(values.days);
  const needsUS = method === 'ultrasound' || method === 'compare';
  if (needsUS && (!validDate(exam) || !Number.isInteger(Number(values.weeks)) || Number(values.weeks) < 0 || Number(values.weeks) > 42 || !Number.isInteger(Number(values.days)) || Number(values.days) < 0 || Number(values.days) > 6 || usDays > 294)) {
    return { error: 'Confira a data do exame e a idade gestacional (até 42 semanas; dias de 0 a 6).' };
  }
  if (['dum', 'cycle', 'compare'].includes(method) && !validDate(dum)) return { error: 'Informe uma DUM válida que não esteja no futuro.' };
  if (method === 'cycle' && (!Number.isInteger(Number(values.cycle)) || Number(values.cycle) < 21 || Number(values.cycle) > 45)) return { error: 'A duração do ciclo deve estar entre 21 e 45 dias.' };
  if (method === 'conception' && !validDate(conception)) return { error: 'Informe uma data de concepção válida que não esteja no futuro.' };
  if (method === 'ivf' && !validDate(transfer)) return { error: 'Informe uma data de transferência válida que não esteja no futuro.' };
  if (needsUS && daysBetween(exam, now) + usDays > 294) return { error: 'A idade gestacional estimada hoje ultrapassa 42 semanas. Confira os dados com sua equipe de saúde.' };
  if (method === 'compare' && dum > exam) return { error: 'A DUM não pode ser posterior à data do ultrassom.' };
  let due;
  let comparison = null;
  if (method === 'dum') due = addDays(dum, 280);
  if (method === 'cycle') due = addDays(dum, 280 + Number(values.cycle) - 28);
  if (method === 'ultrasound') due = addDays(exam, 280 - usDays);
  if (method === 'conception') due = addDays(conception, 266);
  if (method === 'ivf') due = addDays(transfer, Number(values.embryo) === 3 ? 263 : 261);
  if (method === 'compare') {
    const ageByDum = daysBetween(dum, exam);
    const difference = Math.abs(ageByDum - usDays);
    const threshold = redatingThreshold(usDays);
    const useUltrasound = difference > threshold;
    due = useUltrasound ? addDays(exam, 280 - usDays) : addDays(dum, 280);
    comparison = { difference, threshold, useUltrasound, dumDue: addDays(dum, 280), ultrasoundDue: addDays(exam, 280 - usDays) };
  }
  const ageDays = 280 - daysBetween(now, due);
  if (ageDays < 0) return { error: 'As datas indicam uma gestação que ainda não começou. Confira os dados.' };
  if (ageDays > 294) return { error: 'A idade gestacional estimada ultrapassa 42 semanas. Confira os dados com sua equipe de saúde.' };
  return { due, ageDays, remaining: Math.max(0, Math.ceil((280 - ageDays) / 7)), comparison };
}
